module.exports = __webpack_public_path__ + "img/mastercard-card.2191c8df.png";